import { Box, Typography } from '@mui/material'
import { useScreenSize } from '../../../hooks/useScreenSize'
import { ChallengeCard } from '../components'
import { MOCK_REWARDS } from '../mock'

export const RewardsChallenges = () => {
    const { isMobile } = useScreenSize()

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1.5}
            width="100%"
            sx={{ overflowY: 'auto', overflowX: 'hidden' }}
        >
            <Typography textAlign="center" textTransform="uppercase" variant={isMobile ? 'h6' : 'h5'}>
                New available in 7 day
            </Typography>
            {MOCK_REWARDS.challenges.map((item) => (
                <ChallengeCard {...item} />
            ))}
        </Box>
    )
}
